import {Injectable} from "@angular/core";
import {IClinicalRequest} from "../interfaces/clinical.request";
import {IMetadataGroup} from "../../../dev/components/elad.forms2/interfaces/metadata/imetadata.group";
import {ModelBuilder} from "../../../dev/components/elad.forms2/services/model.builder";
import * as _ from "lodash";

/**
 * Created by stanislavk on 16/03/2017.
 */

@Injectable({ providedIn: 'root' })
  export class ClinicalRequestService {
	constructor(private modelBuilder:ModelBuilder) {
	}

	/**
	 * Clones the request in IClinicalRequest format and modifies the request model by setting Ids and by deleting
	 * irrelevant objects added by model builder.
	 * @param metadataGroup Current model metadata.
	 * @param req Request in IClinicalRequest format.
	 * @returns {IClinicalRequest} Cloned request with modified model.
     */
	public clinicalRequestProcess(metadataGroup:IMetadataGroup, req:IClinicalRequest):IClinicalRequest {
		// no need for deep clones - already received cloned from ModelUpdater
		let reqClone:IClinicalRequest = _.clone(req);

		// Together session
		if (Array.isArray(req.model)) {
			reqClone.model.forEach(model => this.modelBuilder.setIds(metadataGroup, model.patient));
			reqClone.model = {patients: req.model};
		} else {
			this.modelBuilder.setIds(metadataGroup, reqClone.model);
			reqClone.model = {patient:req.model};
		}
		return reqClone;
	}
}
